<template>
	<div class="sites-table-page">
		<div class="flex justify-end">
			<vs-button
				color="success"
				type="filled"
				@click="$router.push('/sites/create')"
			>{{ $t('add') }}</vs-button>
		</div>
		<vx-card class="my-8">
			<div class="tab-text ">
				<vs-table :max-items="10" pagination :data="sites">
					<template slot="thead">
						<vs-th v-for="fil in field" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr class="vs-table-filters">
							<template v-for="fil in field">
								<vs-td v-if="fil.field === 'name'">
									<vs-input class="w-full" v-model="searchName" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'uid'">
									<vs-input class="w-full" v-model="searchUID" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'email'">
									<vs-input class="w-full" v-model="searchEmail" @input="filterTable"></vs-input>
								</vs-td>
<!--								<vs-td v-else-if="fil.field === 'phone'">-->
<!--									<vs-input class="w-full" v-model="searchPhone" @input="filterTable"></vs-input>-->
<!--								</vs-td>-->
								<vs-td v-else-if="fil.field === 'commission_manager_percent'">
									<vs-input class="w-full" v-model="searchManagerPercent" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else></vs-td>
							</template>
						</vs-tr>
						<vs-tr :key="indextr"  v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'actions'">
									<div class="flex justify-center">
										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="$router.push(`/sites/edit/${tr.id}`)"
											icon="edit"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-custom-button>

										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="showDeleteDialog(tr.id, tr.name)"
											icon="edit"
										>
											<feather-icon icon="Trash2Icon"></feather-icon>
										</vs-custom-button>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="tr[fil.field]">
									{{tr[fil.field]}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import vSelect from 'vue-select'
import debounce from 'debounce'

export default {
	name: "Authors",
	mixins: [databaseManager, notifier],
	components: {
		'v-select': vSelect,
	},
	data() {
		return {
			searchName: '',
			searchUID: '',
			searchEmail: '',
			searchPhone: '',
			searchManagerPercent: '',

			sites: [],
		};
	},
	methods: {
		showDeleteDialog(id, name) {
			this.$vs.dialog({
				color: "danger",
				title: this.$t('confirmDeletion'),
				acceptText: this.$t('delete'),
				cancelText: this.$t('cancel'),
				text: `${this.$t('doYouWantToDelete')} "${name}"`,
				accept: () => this.removeTask(id),
			});
		},
		async removeTask(id){
			try {
				await this.dbDeleteWebsite(id);

				const index = this.sites.findIndex(item => item.id === id);

				if(index !== -1) this.sites.splice(index, 1);

				this.notifySuccess(this.$t('deletedSuccessfully'));

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		filterTable:  debounce(function (e) {
			let options = {
				name: this.searchName,
				uid: this.searchUID,
				email: this.searchEmail,
				managerPercent: this.searchManagerPercent,
			};

			this.updateTable(options);
		}, 500),
		async updateTable(options) {
			try {
				this.sites = await this.dbGetWebSites(options);

			} catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	created() {
		this.field = [
			{
				field: "name",
				title: this.$t('site'),
				align: 'center',
				width: '18%'
			},
			{
				field: "uid",
				title: this.$t('site') + " ID",
				align: 'center',
				width: '18%'
			},
			{
				field: "email",
				title: "E-Mail",
				align: 'center',
				width: '18%'
			},
			{
				field: "commission_manager_percent",
				title: this.$t('managersFee') + ", %",
				align: 'center',
				width: '18%'
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: 'center',
				width: '10%'
			},
		];
	},
	async mounted() {
		await this.updateTable();
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.sites-table-page {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.vs__selected-options {
		flex-wrap: nowrap;
	}

	.user-info {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}
	.vs-con-table .vs-con-tbody,.vs-table--content{
		overflow: visible;
	}
	.perPage{
		max-width:  80px;
		.vs__dropdown-toggle{
			border-radius: 100px;
		}
		.vs__clear{
			display: none;
		}
		.v-select__selection {
			width: 100%;
			justify-content: center;
		}
	}
	.inputInTable {
		border: 0;
		resize: none;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}
	.justify-center .vs-table-text{
		justify-content: center;
	}
	.vs-checkbox-default{
		flex-shrink: 0;
	}
	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}

		&--tbody {
			overflow: auto !important;
		}
	}
	.con-vs-tabs .con-slot-tabs{
		overflow: visible;
	}

}
</style>
